import React from 'react';
const Error=()=>{
    return(<>
    <>
    <div className="error-container">
        <h1>
        Oops! Something went wrong. Please try again later.
        </h1>
    </div>
    
    </>
    </>)
}
export default Error;